import React from 'react';
import { Controller, ControllerProps, FieldValues, Path } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { Checkbox, FormControlLabel, FormControlLabelProps } from '@mui/material';

export type IsMailingAddressSameProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends Path<TFieldValues> = Path<TFieldValues>
> = { controllerProps: Omit<ControllerProps<TFieldValues, TName>, 'render'> } & Omit<
  FormControlLabelProps,
  'label' | 'control'
>;

export const IsMailingAddressSame = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends Path<TFieldValues> = Path<TFieldValues>
>({
  controllerProps,
  ...formControlLabelProps
}: IsMailingAddressSameProps<TFieldValues, TName>) => {
  return (
    <Controller
      {...controllerProps}
      render={({ field: { value, ref, ...rest } }) => (
        <FormControlLabel
          {...formControlLabelProps}
          control={<Checkbox checked={value ?? false} inputRef={ref} {...rest} />}
          label={<FormattedMessage id="mailing-address-same" defaultMessage="My mailing address is the same" />}
        />
      )}
    />
  );
};
